import { idParam, ROLES } from "../../../helpers/commons.helpers";
import { DESTINATION_MAP_ROLES } from "../services/map.service";

/**
 * Supplier route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with properties
 * used by navigation guards and permission checks.
 *
 * @typedef {Object} SupplierRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires an authenticated session.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/suppliers",
        name: "Suppliers",
        meta: {
            title: "Suppliers",
            modules: ["suppliers"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
            /* webpackChunkName: "suppliers" */ "@/modules/suppliers/pages/Suppliers"
            )
    },
    {
        path: "/suppliers/new",
        name: "NewSupplier",
        meta: {
            title: "New Supplier",
            modules: ["suppliers"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
            /* webpackChunkName: "suppliers" */ "@/modules/suppliers/pages/NewSupplier"
            )
    },
    {
        path: `/suppliers/${idParam()}`,
        name: "SupplierProfile",
        meta: {
            title: "Supplier Profile",
            modules: ["suppliers"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
            /* webpackChunkName: "suppliers" */ "@/modules/suppliers/pages/SupplierProfile"
            )
    },
    {
        path: `/suppliers/${idParam("supplierId")}/destinations/${idParam("branchId")}/map`,
        name: "SupplierDestinationMap",
        meta: {
            title: "Destination Map",
            modules: ["suppliers"],
            requiresAuth: true,
            roles: [...DESTINATION_MAP_ROLES]
        },
        component: () =>
            import(
            /* webpackChunkName: "suppliers" */ "@/modules/suppliers/pages/SupplierDestinationMap"
            )
    }
]